<template>
    <div class="inventory-detail">
        <div class="detail-container">
            <!-- 헤더 스켈레톤: 조직경계 제목 + 뱃지 + 액션 -->
            <div class="detail-header">
                <div class="header-info">
                    <div class="header-primary">
                        <span class="skeleton-box skeleton-title" style="width: 180px; height: 22px;"></span>
                    </div>
                    <div class="header-meta">
                        <span class="skeleton-box skeleton-badge" style="width: 88px; height: 26px; border-radius: 6px;"></span>
                        <span class="skeleton-box skeleton-badge" style="width: 70px; height: 26px; border-radius: 6px;"></span>
                        <span class="skeleton-box skeleton-badge" style="width: 72px; height: 26px; border-radius: 6px;"></span>
                    </div>
                </div>
                <div class="header-actions">
                    <span class="skeleton-box" style="width: 30px; height: 30px; border-radius: 4px;"></span>
                    <span class="skeleton-box" style="width: 30px; height: 30px; border-radius: 4px;"></span>
                </div>
            </div>

            <div class="detail-body">
                <!-- 상단 메트릭 카드 3열 (총 배출량 · 품질 · 불확도) -->
                <div class="top-metrics">
                    <div class="main-metric-card-skeleton">
                        <span class="skeleton-box" style="width: 56px; height: 12px;"></span>
                        <span class="skeleton-box" style="width: 90px; height: 28px; margin: 8px 0 10px 0;"></span>
                        <span class="skeleton-box" style="width: 100%; height: 10px;"></span>
                        <span class="skeleton-box" style="width: 60%; height: 10px;"></span>
                        <span class="skeleton-box" style="width: 70%; height: 10px;"></span>
                    </div>
                    <div class="main-metric-card-skeleton">
                        <span class="skeleton-box" style="width: 56px; height: 12px;"></span>
                        <span class="skeleton-box" style="width: 70px; height: 28px; margin: 8px 0 10px 0;"></span>
                        <span class="skeleton-box" style="width: 90%; height: 10px;"></span>
                    </div>
                    <div class="main-metric-card-skeleton">
                        <span class="skeleton-box" style="width: 56px; height: 12px;"></span>
                        <span class="skeleton-box" style="width: 60px; height: 28px; margin: 8px 0 10px 0;"></span>
                        <span class="skeleton-box" style="width: 85%; height: 10px;"></span>
                    </div>
                </div>

                <!-- 메인 데이터 영역 -->
                <div class="main-data-grid">
                    <!-- 좌측: 산정내역 -->
                    <div class="data-panel main-panel">
                        <div class="panel-header">
                            <span class="skeleton-box" style="width: 60px; height: 12px;"></span>
                            <span class="skeleton-box" style="width: 40px; height: 11px;"></span>
                        </div>
                        <div class="table-container">
                            <div class="skeleton-table">
                                <div class="skeleton-thead">
                                    <span class="skeleton-box" style="width: 60px;"></span>
                                    <span class="skeleton-box" style="width: 80px;"></span>
                                    <span class="skeleton-box" style="width: 50px;"></span>
                                    <span class="skeleton-box" style="width: 50px;"></span>
                                    <span class="skeleton-box" style="width: 70px;"></span>
                                    <span class="skeleton-box" style="width: 50px;"></span>
                                </div>
                                <div v-for="i in 8" :key="'line-' + i" class="skeleton-trow">
                                    <span class="skeleton-box" style="width: 55px;"></span>
                                    <span class="skeleton-box" style="width: 90px;"></span>
                                    <span class="skeleton-box" style="width: 40px;"></span>
                                    <span class="skeleton-box" style="width: 35px;"></span>
                                    <span class="skeleton-box" style="width: 65px;"></span>
                                    <span class="skeleton-box" style="width: 40px;"></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 우측: 요약 테이블들 -->
                    <div class="summary-panels">
                        <!-- 카테고리별 -->
                        <div class="data-panel summary-panel">
                            <div class="panel-header">
                                <span class="skeleton-box" style="width: 70px; height: 12px;"></span>
                                <span class="skeleton-box" style="width: 35px; height: 11px;"></span>
                            </div>
                            <div class="compact-table-container">
                                <div class="skeleton-table">
                                    <div class="skeleton-thead">
                                        <span class="skeleton-box" style="width: 70px;"></span>
                                        <span class="skeleton-box" style="width: 60px;"></span>
                                        <span class="skeleton-box" style="width: 50px;"></span>
                                    </div>
                                    <div v-for="i in 5" :key="'cat-' + i" class="skeleton-trow">
                                        <span class="skeleton-box" style="width: 80px;"></span>
                                        <span class="skeleton-box" style="width: 55px;"></span>
                                        <span class="skeleton-box" style="width: 40px;"></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 시설별 -->
                        <div class="data-panel summary-panel">
                            <div class="panel-header">
                                <span class="skeleton-box" style="width: 50px; height: 12px;"></span>
                                <span class="skeleton-box" style="width: 35px; height: 11px;"></span>
                            </div>
                            <div class="compact-table-container">
                                <div class="skeleton-table">
                                    <div class="skeleton-thead">
                                        <span class="skeleton-box" style="width: 60px;"></span>
                                        <span class="skeleton-box" style="width: 60px;"></span>
                                        <span class="skeleton-box" style="width: 50px;"></span>
                                    </div>
                                    <div v-for="i in 3" :key="'fac-' + i" class="skeleton-trow">
                                        <span class="skeleton-box" style="width: 70px;"></span>
                                        <span class="skeleton-box" style="width: 55px;"></span>
                                        <span class="skeleton-box" style="width: 40px;"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InventoryDetailSkeleton",
};
</script>

<style scoped>
.inventory-detail {
    display: flex;
    flex-direction: column;
    height: 100%;
    font-size: 12px;
}

.detail-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* 헤더 (InventoryDetailView와 동일 구조) */
.detail-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: #ffffff;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}

.header-info {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}

.header-primary {
    flex-shrink: 0;
}

.skeleton-title {
    border-radius: 4px;
}

.header-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.skeleton-badge {
    flex-shrink: 0;
}

.header-actions {
    display: flex;
    gap: 2px;
}

/* Body */
.detail-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px;
    min-height: 0;
    overflow: hidden;
}

/* 상단 메트릭 카드 3열 */
.top-metrics {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-shrink: 0;
}

.main-metric-card-skeleton {
    display: flex;
    flex-direction: column;
    padding: 14px 16px;
    border-radius: 8px;
    background: #f0f4f0;
    border: 1px solid #e0e0e0;
    position: relative;
    overflow: hidden;
}

/* 메인 데이터 그리드 */
.main-data-grid {
    display: grid;
    grid-template-columns: 1fr 260px;
    gap: 10px;
    flex: 1;
    min-height: 0;
}

.data-panel {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    min-height: 0;
    align-self: flex-start;
}

.main-panel {
    min-width: 0;
}

.summary-panels {
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
}

.summary-panel {
    display: flex;
    flex-direction: column;
    min-height: 0;
    width: 100%;
    align-self: flex-start;
}

.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
}

/* 테이블 */
.table-container,
.compact-table-container {
    flex: 0 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: auto;
    max-height: 38vh;
}

.compact-table-container {
    max-height: 20vh;
}

.skeleton-table {
    width: 100%;
}

.skeleton-thead {
    display: flex;
    gap: 8px;
    padding: 6px 8px;
    background: #fafafa;
    border-bottom: 1px solid #e0e0e0;
}

.skeleton-trow {
    display: flex;
    gap: 8px;
    padding: 8px;
    border-bottom: 1px solid #f5f5f5;
}

.skeleton-trow:last-child {
    border-bottom: none;
}

.skeleton-box {
    display: inline-block;
    background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
    background-size: 200% 100%;
    border-radius: 3px;
    animation: shimmer 1.5s infinite linear;
    flex-shrink: 0;
}

@keyframes shimmer {
    0% {
        background-position: 200% 0;
    }

    100% {
        background-position: -200% 0;
    }
}

@media (max-width: 1400px) {
    .main-data-grid {
        grid-template-columns: 1fr;
    }

    .summary-panels {
        flex-direction: row;
    }

    .summary-panel {
        flex: 1;
    }
}

@media (max-width: 1024px) {
    .summary-panels {
        flex-direction: column;
    }

    .top-metrics {
        grid-template-columns: 1fr;
    }
}
</style>